import { CurrencyPipe } from '@angular/common';
import type { PipeTransform } from '@angular/core';
import { inject, Pipe } from '@angular/core';

import { BaseDirective } from '@valk-nx/core/lib/directives/base/base.directive';

@Pipe({
	name: 'price',
	pure: true,
})
export class PricePipe extends BaseDirective implements PipeTransform {
	private readonly currencyPipe = inject(CurrencyPipe);

	transform(priceInCents: number, currency: string): string | null {
		return this.currencyPipe.transform(
			priceInCents / 100,
			currency,
			'symbol-narrow',
			'1.2-2',
			this.language(),
		);
	}
}
